import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import courseReducer from '../features/courses/courseSlice';
import lessonReducer from '../features/lessons/lessonSlice';
import enrollmentReducer from '../features/enrollments/enrollmentSlice';
import progressReducer from '../features/progress/progressSlice';
import liveReducer from '../features/live/liveSlice';
import uiReducer from '../features/ui/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    courses: courseReducer,
    lessons: lessonReducer,
    enrollments: enrollmentReducer,
    progress: progressReducer,
    live: liveReducer,
    ui: uiReducer,
  },
});